<template>
  <div id="main">

    <v-dialog v-model="visible" max-width="80%" persistent>
      <v-card>

        <v-card-text class="txt-color">
          Opps looks like an error occured... <br>
          Please copy and paste the error details below and email to tech support (motoi@espy.ai)

          <v-textarea
                  id="error_element"
                  class="pt-2"
                  v-model="disp_error"
                  auto-grow
                  readonly
                  outline
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
        <v-spacer></v-spacer>
          <v-btn color="accent" @click="copy_error">Copy Error Message</v-btn>
        <v-btn color="accent" @click="close">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>



  </div>
</template>

<style scoped>
.txt-color{
  color: red;
}


</style>


<script>
   import axios from 'axios';


   export default {

      props: {
         error: Object,
         value: Boolean,  //used to control if the dialog is visibility

      },
      data() {
         return {
            visible: this.value,
            error2: '',
         };
      },

      watch:{
         value(){
            this.visible = this.value;
         },

         visible(){
            this.$emit('input', this.visible);
         },

         // error(){
         //    let keys = Object.keys(this.error2);
         //
         //    console.log(keys);
         //
         //    //check if it's an axios error
         //    if (keys.includes('response') ){
         //       console.log(this.error.response.data);
         //       // this.error2 =
         //
         //    }
         //
         // }



      },

      computed:{
         disp_error(){

            if (this.error !== null){
               let msg = this.error.msg;
               return 'Error Message: ' + msg +'\n\n' +  JSON.stringify(this.error);

            }
            else{
               return '';
            }
         }

      },


      methods:{

         copy_error(){
            let el = document.getElementById('error_element');
            el.select();
            document.execCommand("copy");

         },

         close(){
            this.visible = false;

         },



      },
   };
</script>
